import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
import * as yup from 'yup';

import { useSession } from '../../providers/SessionProvider';

import LoginHeader from '../../components/LoginHeader';
import Input from '../../components/Input';
import MyLoadingOverlay from '../../components/MyLoadingOverlay';

import { getValidationSchema } from '../../utils/schemas';

function Login() {
  const { doLogin, isLoading } = useSession();
  const formLoginRef = useRef(null);

  const handleLogin = useCallback(async data => {
    try {
      // Remove all previous errors
      formLoginRef.current.setErrors({});

      const loginSchema = getValidationSchema('login');
      const schema = yup.object().shape(loginSchema);

      await schema.validate(data, {
        abortEarly: false,
      });

      doLogin(data);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });

        formLoginRef.current.setErrors(validationErrors);
      }
    }
  }, []);

  return (
    <div className="gray">
      <LoginHeader />

      <section className="login">
        <div className="container">
          <h2>Acesse sua conta na ABAF</h2>
          <Form onSubmit={handleLogin} ref={formLoginRef} className="grid_5">
            <p>
              <Input type="email" name="email" placeholder="E-mail:" />
            </p>
            <p>
              <Input type="password" name="password" placeholder="Senha:" />
            </p>
            <p>
              <button type="submit">entrar</button>
            </p>
            <p>
              <Link to="/lembrete">Esqueceu sua senha?</Link>
            </p>
          </Form>
          <div className="register">
            <h4>Ainda não é Agente Associado?</h4>
            <a href="/">Clique aqui e saiba mais</a>
          </div>
        </div>
      </section>

      {isLoading && <MyLoadingOverlay />}
    </div>
  );
}

export default Login;
